import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import {ApiServices} from '../../shared/services/api.service';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {DataService} from '../../shared/services/data.service';
import {MetaService} from '../../shared/services/meta.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HelperService} from '../../shared/services/helper.service';
import { DOCUMENT } from '@angular/common';
import { Plan } from 'src/app/shared/interfaces/MyAccount.interface';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  registerProcessing = false;
  registerSubscription: Subscription;
  signupform = false;
  loginform = true;


  usStates: any;
  countries:any;
  plans:Array<Plan> = [];
  showUSstate:boolean = true;

  trade_license_file:any = '';
  trade_license_filename:any = '';

  termTitle: any = '';
  termBody: any = '';

  privacyTitle:any = '';
  privacyBody:any = '';

  isVendor = false;

  constructor(
    private apiService: ApiServices,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private dataService: DataService, private metaService: MetaService, private activatedRoute: ActivatedRoute,private helperService: HelperService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
  ) {


    const token = localStorage.getItem('ts_vendor_access_token');
    // console.log(token);
    if(token) {
      this.apiService.myAccount().subscribe(
        response => {
          this.dataService.myAccountData.next(response.data);
          this.dataService.isLoggedIn.next(true);
          this.router.navigateByUrl('/my-account/my-profile');
        }, error => {
          this.helperService.logout();
        }
      );
    }


    this.form = this.fb.group({
      business_name: ['', [Validators.required, Validators.maxLength(50)]],
      // name: ['', [Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      country: ['', [Validators.required, Validators.maxLength(50)]],
      plan: ['starter-plan'],
      type: ['Retailer', [Validators.required, Validators.maxLength(50)]],
      trade_license: ['', [Validators.required]],
      termCheckbox: ['', [Validators.required]],
      privacyCheckbox: ['', [Validators.required]],
    });

    helperService.setPageTitle(activatedRoute.snapshot.data.title);
    if(activatedRoute.snapshot.queryParams.plan) {
      this.form.controls.plan.patchValue(activatedRoute.snapshot.queryParams.plan);
      this.showSignUp();
    }

    if(activatedRoute.snapshot.queryParams.signup) {
      this.showSignUp();
    }
  }

  ngOnInit(): void {
    this.metaService.updateCanonicalURL();

    let metaData: any = {
      title: this.activatedRoute.snapshot.data.breadcrumbs.title,
      description: this.activatedRoute.snapshot.data.breadcrumbs.description,
    };

    this.helperService.setCustomMeta(metaData);
    // this.renderer.addClass(this.document.body, 'loginpage');


    this.apiService.usStates().subscribe(response => {
      this.usStates = response.data.states;
      // console.log(response.data.states);
    });

    this.apiService.getCountries().subscribe(response => {
      this.countries = response.data.countries;

      this.form.value.country = 'United States';
    });

    this.apiService.getPlans().subscribe(({data}) => {
      this.plans = data.plans;
    });

    this.getTermPageData();
    this.getPrivacyPageData();


  }

  onRegister():void {

    if(this.form.value.type == 'Brand'){
      this.onRegisterVendor();
    }else{
      this.onRegisterDealer();
    }

  }

  onFileChange(event):void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.trade_license_file =  event.target.files[0];
      this.form.patchValue({
        trade_license: file
      });
    }
    console.log(this.form.get('trade_license').value);
  }

  onRegisterDealer(): void {
    if (this.form.valid) {
      this.registerProcessing = true;
      // const name = this.form.value.name.split(' ');
      // const formData = {
      //   first_name: name[0],
      //   last_name: name[1] ? name[1] : '',
      //   email: this.form.value.email,
      //   password: this.form.value.password,
      //   country: this.form.value.country,
      //   business_name: this.form.value.business_name,
      // };


      const formData: FormData = new FormData();
      formData.append('trade_license', this.trade_license_file, this.trade_license_file.name);
      formData.append('email', this.form.value.email);
      formData.append('password', this.form.value.password);
      formData.append('country', this.form.value.country);
      formData.append('business_name', this.form.value.business_name);
      formData.append('name', this.form.value.business_name);
      formData.append('plan', this.form.value.plan);


      this.registerSubscription = this.apiService.register(formData).subscribe(
        response => {
          this.registerProcessing = false;
          if (response.status) {
            this.dataService.isLoggedIn.next(true);
            localStorage.setItem('ts_user_data', JSON.stringify(response.data));
            localStorage.setItem('ts_vendor_access_token', response.data.access_token);
            this.toastr.success(response.message, 'Success');
            this.router.navigateByUrl('/my-account/my-profile');
          } else {
            this.registerProcessing = false;
            this.toastr.error(response.message, 'Error');
          }
        }, error => {
          this.registerProcessing = false;
          this.toastr.error(error.error.errors, 'Error');
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  onRegisterVendor(): void {
    if (this.form.valid) {
      this.registerProcessing = true;
      // const name = this.form.value.name.split(' ');

      const formData: FormData = new FormData();
      formData.append('logo', this.trade_license_file, this.trade_license_file.name);
      formData.append('email', this.form.value.email);
      formData.append('password', this.form.value.password);
      formData.append('country', this.form.value.country);
      formData.append('business_name', this.form.value.business_name);
      formData.append('name', this.form.value.business_name);
      // formData.append('first_name', name[0]);
      // formData.append('last_name', name[1] ? name[1] : '');

      this.registerSubscription = this.apiService.vendorRegister(formData).subscribe(
        response => {
          this.registerProcessing = false;
          if (response.status) {
            // this.dataService.isLoggedIn.next(true);
            // localStorage.setItem('ts_vendor_access_token', response.data.access_token);
            this.form.reset();
            const fileInput = document.getElementById('fileInput') as HTMLInputElement;
            fileInput.value = '';
            this.toastr.success(response.message, 'Success');
            // this.router.navigateByUrl('/my-account/my-profile');
          } else {
            this.registerProcessing = false;
            this.toastr.error(response.message, 'Error');
          }
        }, error => {
          this.registerProcessing = false;
          this.toastr.error(error.error.errors, 'Error');
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  onCountrySelect(event): void {
    if(event.target.value == 'United States'){
      this.showUSstate = true;
    }else{
      this.showUSstate = false;
    }
  }


  showSignIn():void{
    this.loginform = true;
    this.signupform = false;
  }

  showSignUp():void{
    this.signupform = true;
    this.loginform = false;
  }


  getTermPageData() {
    this.apiService.getFooterPage('terms-conditions').subscribe(response => {
      if(response.status == true){
        this.termTitle = response.data.title;
        this.termBody = response.data.body;
      }
    },
    error => {
      this.termBody = '<section class="ny-text-section">';
      this.termBody += '<div class="container-fluid">';
        this.termBody += '<div class="row">';
          this.termBody += '<div class="col-md-12">';
            this.termBody += '<div class="ny-confirmation">';
              this.termBody += '<img src="assets/img/n-false.png" alt="img" />';
              this.termBody += '<h1>Sorry,</h1>';
              this.termBody += '<p>Page not found!</p>';
            this.termBody += '</div>';
          this.termBody += '</div>';
        this.termBody += '</div>';
      this.termBody += '</div>';
    this.termBody += '</section>';
    }
    );
  }

  getPrivacyPageData() {
    this.apiService.getFooterPage('privacy-policy').subscribe(response => {
      if(response.status == true){
        this.privacyTitle = response.data.title;
        this.privacyBody = response.data.body;
      }
    },
    error => {
      this.privacyBody = '<section class="ny-text-section">';
      this.privacyBody += '<div class="container-fluid">';
        this.privacyBody += '<div class="row">';
          this.privacyBody += '<div class="col-md-12">';
            this.privacyBody += '<div class="ny-confirmation">';
              this.privacyBody += '<img src="assets/img/n-false.png" alt="img" />';
              this.privacyBody += '<h1>Sorry,</h1>';
              this.privacyBody += '<p>Page not found!</p>';
            this.privacyBody += '</div>';
          this.privacyBody += '</div>';
        this.privacyBody += '</div>';
      this.privacyBody += '</div>';
    this.privacyBody += '</section>';
    }
    );
  }

  ngAfterViewInit() {
    // Add a class to the body element
    this.renderer.addClass(document.body, 'bg-black');
  }


  ngOnDestroy() {
    if(this.registerSubscription) {
      this.registerSubscription.unsubscribe();
    }
     this.renderer.removeClass(this.document.body, 'loginpage');

     this.renderer.removeClass(document.body, 'bg-black');
  }
  
  

}
